/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Isset1Inputs */

const en_entity_isset1 = /** @type {(inputs: Entity_Isset1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Set`)
};

const de_entity_isset1 = /** @type {(inputs: Entity_Isset1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist gesetzt`)
};

/**
* | output |
* | --- |
* | "Is Set" |
*
* @param {Entity_Isset1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_isset1 = /** @type {((inputs?: Entity_Isset1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Isset1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_isset1(inputs)
	return de_entity_isset1(inputs)
});
export { entity_isset1 as "entity_isSet" }